<template>
  <div class="moow-master-container play-background">

    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <b-container>
      <div class="md-layout">
        <div class="md-layout-item">
          <p class="moow-header large" style="text-align:center">Continue With Tenant Details</p>               
        </div>
      </div>

      <div class="md-layout mt-5">

        <div class="md-layout-item">
          <md-card md-with-hover class="island-card">
            <md-card-header>
              <p class="moow-header">Continue Now</p>
            </md-card-header>
            <md-card-content>
              <p class="moow-info-txt large">Fill out tenant details and finish application now.</p>
            </md-card-content>
            <md-card-actions >
              <md-button @click="proceed()" class="md-primary play-cta-button makeup mt-5">Proceed</md-button>
            </md-card-actions>
          </md-card>
        </div>

        <div class="md-layout-item md-size-10 md-small-size-100 dynamic-separator mb-5">
          <p class="moow-info">OR</p>
        </div>

        <div class="md-layout-item">
          <md-card md-with-hover class="island-card">
            <md-card-header>
              <p class="moow-header">Ask tenant to finish up</p>
            </md-card-header>
            <md-card-content>
              <p class="moow-info">Share the link with tenant who will finalize the application.</p>
              <md-field>
                <label>Sharable link</label>
                <md-textarea v-model="shareableLink" readonly id="shareableLinkHolder"></md-textarea>
                <span class="md-helper-text">Tenant can finalize the application using this link</span>
              </md-field>
            </md-card-content>
            <md-card-actions >
              <md-button @click="copyLink()" class="md-primary play-cta-button-flat makeup">Copy link</md-button>
            </md-card-actions>
          </md-card>
          



        </div>
      </div>
      

      <div class="md-layout mt-3">
        <div class="md-layout-item">
          <md-button @click="close()" class="md-primary play-cta-button-flat grey">Close</md-button>
        </div>
      </div>
 
    </b-container>

        <moow-dialog-confirm
      title="Close progress?"
      content="Make sure you save the link before. Once application has been finished, it will appear under Deals section on your dashboard."
      confirmText="Close"
      cancelText="Wait"
      :showDialog="confirmationDialog"
      @mConfirm="onConfirmConfirmation"
      @mCancel="onCancelConfirmation"
    />



    <error-snackbar
      :message="snackbarMessage"
      :duration="Number(4000)"
      :showSnackbar="showSnackbar"
      position="center"
      :isInfinity="false">
    </error-snackbar>
  </div>
</template>

<script>
  import PropertySelector from '@/components/property/propertySelector.vue'
  import Snackbar from '@/components/snackbar.vue'
  import { encodeObjectToString } from '@/platform/utils/encoding/encoderService.js'
  export default {
    props: {
    },
    components: {
      'error-snackbar': Snackbar,
      'property-selector': PropertySelector
    },
    data() {
      return {
        loading: false,
        confirmationDialog: false,
        shareableLink: "",
        snackbarMessage: "",
        showSnackbar: false,
        application: undefined
      }
    },
    filters: {
    },
    mounted(){
      this.createSharableUrl(this.$store.getters.dealApplication)
    },
    created(){
      this.proceed()
    },
    watch:{

    },
    computed: {
 
    },
    methods: {
      createSharableUrl(application){
        this.shareableLink=this.getBaseUrl() + "/#/application/lessee?encontent="+this.encodePayload(application)
      },
      encodePayload(application){
        // TODO: replace dummys with values from 'dealApplication'
        var content = {
          application: application,
          healthy: true
        }
        return encodeObjectToString(content)
      },
      getBaseUrl(){
        return window.location.host
      },
      proceed(){
        if(this.$store.getters.property._id) this.changeView("dealApplicationLessee")
        else this.showSnackbar("Something is not right")
      },
      close(){
        this.confirmationDialog=true
        this.copyLink()
      },
      copyLink(){
        if(this.shareableLink){
            /* Get the text field */
          var copyText = document.getElementById("shareableLinkHolder")

          /* Select the text field */
          copyText.select();
          copyText.setSelectionRange(0, 99999); /*For mobile devices*/

          /* Copy the text inside the text field */
          document.execCommand("copy");

          /* Alert the copied text */
          this.showUserMessage("Link copied to clipboard")
        }else this.showUserMessage("Link not ready yet!")
      },
      onConfirmConfirmation(){
        this.changeView("dashboard")
      },
      onCancelConfirmation(){
        this.confirmationDialog=false
      },
      showUserMessage(message){
        this.snackbarMessage = message
        this.showSnackbar=true
      },
      changeView(name, params){
        this.$router.push({
          name: name,
          params: params
        })
      }
    }
  }
</script>
<style scoped>
  @import '../../../assets/styles/booking.css';
  @import '../../../assets/styles/dashboard.css';
  @import '../../../assets/styles/global.css';

  .dynamic-separator{
  	text-align:center;
  }

  .dynamic-separator p{
    top: 50%;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/bookings/deals/DealApplicationDecision.vue